export const formatNumber = (value: number | string, separator = ' ', digits = 2): string => {
    const val = parseFloat(String(value));
    const formatted = val
        .toFixed(digits)
        .replace(/(\d)(?=(\d{3})+(\.|$))/g, `$1${separator}`)
        .replace(/\./g, ',');
    return formatted.endsWith('00') ? formatted.replace(/,\d{2}/, '') : formatted;
};

export const formatFloat = (
    value: string | number,
    digits = 2,
    separator = '&nbsp;',
    removeTrailingZeros = true,
): string => {
    const val = parseFloat(String(value));
    const formatted = val
        .toFixed(digits)
        .replace(/(\d)(?=(\d{3})+(\.|$))/g, `$1${separator}`)
        .replace(/\./g, ',');
    return formatted.endsWith('00') && removeTrailingZeros
        ? formatted.replace(/,\d{2}/, '')
        : formatted;
};

export const formatRubles = (value: number | string, separator = ' '): string =>
    `${formatNumber(value, separator)}\u00a0₽`;

export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
